import { Box, styled } from '@mui/material';
import SideNavbar from '../../shared/components/sideNavbar';
import Navbar from '../../shared/components/navbar';
import { ReactNode } from 'react';

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

interface LayoutBaseProps {
  children: ReactNode;
  footer?: ReactNode;
}

const LayoutBase = ({ children, footer }: LayoutBaseProps) => {
  return (
    <>
      <Navbar />
      <Box sx={{ display: 'flex', minHeight: '100vh', flexDirection: 'column' }}>
        <Box sx={{ display: "flex", flexGrow: 1 }}>
          <SideNavbar />
          <Box component="main"
            sx={{
              flexGrow: 1,
              p: 3,
              flexDirection: "column",
              height: "auto",
              width: "100%",
              minHeight: "100%",
              transition: 'margin 0.3s',
              marginLeft: 2,
            }}>
            <DrawerHeader />
            {children}
          </Box>
        </Box>
        <Box component="footer" sx={{ textAlign: 'center', padding: 2, marginLeft: 'auto', marginRight: 'auto' }}>
          {footer}
        </Box>
      </Box >
    </>
  )
}

export default LayoutBase;